/* ============================================================
   REVOLOR Native Cart Discount Handler
   Uses /cart/update.js { discount: "CODE" } (Shopify Summer '25)
   Single cart system — no Storefront API needed
   ============================================================ */

(function () {
  'use strict';

  /**
   * Apply a discount code to the cart.
   * @param {string} code — discount code (empty string = remove all)
   * @returns {Promise<Object>} — the updated cart object
   */
  function applyDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code || '' })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart update failed: ' + res.status);
      return res.json();
    });
  }

  /**
   * Remove all discount codes from the cart.
   * @returns {Promise<Object>}
   */
  function removeDiscount() {
    return applyDiscount('');
  }

  /**
   * Refresh the cart drawer via Section Rendering.
   * @returns {Promise<void>}
   */
  function refreshDrawer() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return Promise.resolve();

    // Use Dawn's native onCartUpdate if available
    var cartItems = document.querySelector('cart-drawer-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      return cartItems.onCartUpdate();
    }

    // Fallback: manual section fetch
    return fetch('/?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var selectors = ['cart-drawer-items', '.drawer__footer'];
        selectors.forEach(function (sel) {
          var newEl = doc.querySelector(sel);
          var oldEl = document.querySelector(sel);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });
      });
  }

  /**
   * Apply discount + refresh drawer in one call.
   * @param {string} code
   * @returns {Promise<Object>} — the cart object with discount_codes
   */
  function applyAndRefresh(code) {
    return applyDiscount(code).then(function (cart) {
      return refreshDrawer().then(function () { return cart; });
    });
  }

  /**
   * Remove discount + refresh drawer.
   * @returns {Promise<Object>}
   */
  function removeAndRefresh() {
    return removeDiscount().then(function (cart) {
      return refreshDrawer().then(function () { return cart; });
    });
  }

  /**
   * Detect /discount/CODE URLs and auto-apply.
   */
  function detectDiscountUrl() {
    var match = window.location.pathname.match(/\/discount\/([^/?#]+)/i);
    if (match) {
      var code = decodeURIComponent(match[1]);
      applyDiscount(code);
    }
  }

  // Auto-detect on load
  detectDiscountUrl();

  // Public API
  window.CartDiscount = {
    apply: applyDiscount,
    remove: removeDiscount,
    applyAndRefresh: applyAndRefresh,
    removeAndRefresh: removeAndRefresh,
    refreshDrawer: refreshDrawer
  };
})();
